module.exports = __webpack_public_path__ + "static/img/payshibai.5966cc13.png";